import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=22fd5afe&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=22fd5afe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports